var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "48", height: "48", viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { clipPath: "url(#svg852191641a)" },
      React.createElement("path", { d: "M45.798 43.626H2.181a2.181 2.181 0 1 0 0 4.363h43.616a2.18 2.18 0 1 0 .001-4.363zM4.907 37.955a2.181 2.181 0 1 0 0 4.364h38.164a2.182 2.182 0 0 0 0-4.364h-.544V18.326h.544a1.089 1.089 0 1 0 0-2.179H4.907a1.09 1.09 0 1 0 0 2.18h.545v19.627h-.545zm33.257-19.629v19.628h-6.542V18.326h6.542zm-10.905 0v19.628h-6.542V18.326h6.542zm-17.446 0h6.542v19.628H9.813V18.326zM2.181 14.186H45.82a2.18 2.18 0 0 0 .707-4.245L24.886.203a2.185 2.185 0 0 0-1.79 0l-21.81 9.813a2.18 2.18 0 0 0 .895 4.17z" })
    ),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "clipPath",
        { id: "svg852191641a" },
        React.createElement("path", { fill: "#fff", d: "M0 0h48v48H0z" })
      )
    )
  );
});